module.exports = __webpack_public_path__ + "static/img/11.f6842fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/11.png
// module id = DY55
// module chunks = 0